import { isNotDefined } from '@hsp/utilities';

import { AudienceParameters } from 'types/api';
import { DashboardTabs } from 'types/pages/audience-builder/dashboard';

export const dashboardQueryKeys = {
  audiences: {
    all: ['user-audiences'],
    byParameter: (tab: DashboardTabs, parameters?: AudienceParameters) =>
      [...dashboardQueryKeys.audiences.byTab(tab), { ...parameters }] as const,
    byTab: (tab: DashboardTabs) => [...dashboardQueryKeys.audiences.all, { tab }] as const,
  },
  shops: {
    all: ['user-audience-shops'],
    byId: (id?: string | null, userId?: string) => {
      if (isNotDefined(userId)) {
        return [...dashboardQueryKeys.shops.all, { id }] as const;
      }

      return [...dashboardQueryKeys.shops.all, { id, userId }] as const;
    },
  },
} as const;
